/**
 * Formata data para "mês/ano" em português, ex.: "maio/2026".
 * Usado em todas as listagens e páginas de publicações.
 */
export function formatMonthYear(dateString: string | null | undefined): string {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return "";
  const month = d.toLocaleDateString("pt-BR", { month: "long" });
  return `${month}/${d.getFullYear()}`;
}
